var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.195 6.97a6.97 6.97 0 1 1-13.94 0 6.97 6.97 0 0 1 13.94 0M1.473 24.911c-.433 0-.844-.19-1.126-.517-.282-.329-.375-.894-.34-1.2.01-.056.036-.21.086-.419.057-.238.148-.567.286-.955.276-.773.749-1.804 1.54-2.84 1.626-2.126 4.494-4.126 9.306-4.126s7.68 2 9.305 4.127a10.5 10.5 0 0 1 1.54 2.84c.139.387.23.716.287.954.05.209.076.363.086.42.034.305-.058.87-.34 1.199a1.49 1.49 0 0 1-1.126.517z"
  })));
};
export default SvgProfile;